import React, { Fragment, FunctionComponent, useState, useContext, useEffect } from 'react';

import { Text } from '../../../shared/Text';
import { StepperContent, StepperHeader, StepperSubmit } from '../../../shared/Stepper';
import { useForm } from 'react-hook-form';
import { Input } from '../../../shared/Input/Input';
import { formItems } from '../formItems';
import { FormContext } from '../../../../store/context/formContext';
import { numberToCurrency } from '../../../../utils/prices';
import { parseSearchQuery } from '../../../../utils/params';

export const Step1: FunctionComponent<{ id: number }> = ({ id }) => {
    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors, isValid },
    } = useForm<any>({
        mode: 'onBlur',
    });

    const [completedText, setCompletedText] = useState('');

    const { updateForm, form } = useContext(FormContext);

    const { bedrag } = parseSearchQuery(window.location.search);

    const onSubmit = (data: any) => {
        updateForm(data);
        setCompletedText(numberToCurrency(data[formItems.monthlyCost], true));
    };

    useEffect(() => {
        if (form) {
            Object.entries(form).forEach((item: any[]) => {
                setValue(item[0], item[1], { shouldValidate: true });
            });
        }
        if (bedrag) {
            setValue(formItems.monthlyCost, bedrag)
        }
    }, [form, setValue]);

    return (
        <Fragment>
            <StepperHeader title="Jouw gegevens" id={id} completedText={completedText} />

            <StepperContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Text as="h3">Hoeveel wil je maximaal lenen?</Text>

                    <Input
                        label="Hoeveel wil je (bruto) per maand betalen?*"
                        type="currency"
                        name={formItems.monthlyCost}
                        id={formItems.monthlyCost}
                        placeholder="€"
                        value={getValues(formItems.monthlyCost)}
                        register={register}
                        hasError={errors[formItems.monthlyCost]}
                        validation={{ required: true }}
                    />

                    {errors[formItems.monthlyCost] && (
                        <span className="form__error">Vul een geldig bedrag in</span>
                    )}

                    <StepperSubmit id={id} isValidated={isValid} />
                </form>
            </StepperContent>
        </Fragment>
    );
};
